angular.module('iconoglobe').directive('googleplace',['$location','$state', '$window', "localStorageService", function(location, route, window, localStorageService) {
    return {
		restrict: "AE",
        require: 'ngModel',
        scope: { someCtrlFn: '&callbackFn' },
        link: function(scope, element, attrs, model) {
            var options = {
                types: ['(cities)'],
				language: 'zh-TW'
            };
			
            scope.gPlace = new google.maps.places.Autocomplete(element[0], options);
	
            google.maps.event.addListener(scope.gPlace, 'place_changed', function() {
				angular.element('.location-popup-wrap').toggleClass('active');
				var location_location = scope.gPlace.getPlace().geometry.location;
				console.log("inside google place received response",scope.gPlace.getPlace());
				var searchCityInfo=scope.getAddressComponentByPlace(scope.gPlace.getPlace());
				if(location.path()=='/'){
					location.path('/').search({'at': location_location.lng() + "," + location_location.lat()});
					scope.setChildMapview(searchCityInfo);
					
				}else{
					location.path('/').search({'at': location_location.lng() + "," + location_location.lat()});
				}
				localStorageService.set('city_search', true);
                localStorageService.set('city_info', JSON.stringify(searchCityInfo));
				element.val('');
				scope.$apply();
            });
        },
		controller: ["$scope", "$rootScope", function(scope, rootScope){
			scope.setChildMapview = function(searchCityInfo){
                localStorageService.set('city_search', true);
                localStorageService.set('city_info', JSON.stringify(searchCityInfo));
				rootScope.$broadcast ('setMapview', {
					location: 'city'
				});
			},
			scope.getAddressComponentByPlace =function(place){
                 var components;
                 components = {};
                 angular.forEach(place.address_components, function(address_component) {
                   angular.forEach(address_component.types, function(type) {
                      components[type] = address_component.long_name;
                     });
                 });
                   return components;
            }
		}]
    };
}]);